class CollectionTabs {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.sectionId = this.section.getAttribute("data-id");
    this.tabButtons = this.section.querySelectorAll(".collection-tab-btn");
    this.tabLinks = this.section.querySelectorAll(".feature-collection-link");
    this.tabPanels = this.section.querySelectorAll(".collection-tab-panel");
    this.init();
  }

  init() {
    this.tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const tabId = button.getAttribute("data-tab");
        this.switchTab(tabId);
      });
    });
  }

  switchTab(tabId) {
    this.tabButtons.forEach((button) => {
      if (button.getAttribute("data-tab") === tabId) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });
    this.tabLinks.forEach((link) => {
      if (link.getAttribute("data-tab") === tabId) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });

    this.tabPanels.forEach((panel) => {
      if (panel.id === `${tabId}-${this.sectionId}`) {
        panel.classList.add("active");
      } else {
        panel.classList.remove("active");
      }
    });

    window.dispatchEvent(new Event("resize"));
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const tabSections = document.querySelectorAll("[data-id]");
  tabSections.forEach((section) => {
    if (section.querySelector(".collection-tabs")) {
      new CollectionTabs(section);
    }
  });
});
